import React, { useEffect } from 'react';
import classNames from 'classnames';
import { SECTION_POST_LIST } from '@wix/communities-blog-client-common';
import { useSelector } from '@app/external/common/components/runtime-context';
import stylesParams from '../../../../components/PostList/stylesParams';
import ResponsiveListener from '../../../common/components/responsive-listener/responsive-listener';
import { withReduxStore } from '../../../common/components/runtime-context/with-redux-store';
import { PostTitleTagProvider } from '../../../common/context/post-title-tag-context';
import {
  getIsCreatedWithResponsiveEditor,
  getLayoutMargins,
  getUseMobileDesignSettings,
  getUseMobileLayoutSettings,
} from '../../../common/selectors/app-settings-selectors';
import { getLayoutType } from '../../../common/selectors/layout-selectors';
import { getIsMobile, isEditor } from '../../../common/store/basic-params/basic-params-selectors';
import PostList from '../post-list';
import styles from './app-root.scss';

const AppRoot: React.FC = () => {
  const isEditorMode = useSelector(isEditor);
  const createdWithResponsiveEditor = useSelector(getIsCreatedWithResponsiveEditor);
  const useMobileDesign = useSelector(getUseMobileDesignSettings);
  const isMobile = useSelector(getIsMobile);
  const useMobileLayoutSettings = useSelector(getUseMobileLayoutSettings);

  const layoutMargins = useSelector((state) =>
    getLayoutMargins({
      state,
      section: SECTION_POST_LIST,
      layoutType: getLayoutType(state, SECTION_POST_LIST, useMobileLayoutSettings),
    }),
  );

  const padding =
    (isMobile && !useMobileLayoutSettings) || createdWithResponsiveEditor ? 0 : layoutMargins;

  useEffect(() => {
    if (isEditorMode && createdWithResponsiveEditor) {
      document.body.style.height = 'auto';
    }
  }, [isEditorMode, createdWithResponsiveEditor]);

  return (
    <PostTitleTagProvider titleFontParam={stylesParams.titleFont} fallbackTagName="h2">
      <ResponsiveListener dataHook="post-list-root">
        <div
          style={{ padding }}
          className={classNames(
            styles.root,
            useMobileDesign ? styles.mobileBaseStyles : styles.baseStyles,
          )}
        >
          <PostList />
        </div>
      </ResponsiveListener>
    </PostTitleTagProvider>
  );
};

export default withReduxStore(AppRoot);
